import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import PortalLayout from "@/components/PortalLayout";
import Dashboard from "@/pages/Dashboard";
import Envoyer from "@/pages/Envoyer";
import PoleView from "@/pages/PoleView";
import Recherche from "@/pages/Recherche";
import Admin from "@/pages/Admin";
import Login from "@/pages/Login";
import TicketsList from "@/pages/TicketsList";
import TicketDetail from "@/pages/TicketDetail";
import Commandes from "@/pages/Commandes";
import Performance from "@/pages/perf/Performance";
import PerformanceProposal from "@/pages/perf/PerformanceProposal";
import PerfAdminMockup from "@/pages/perf/PerfAdminMockup";
import PerfAdmin from "@/pages/perf/PerfAdmin";
import Portal from "@/pages/portal/Portal";
import PortalNew from "@/pages/portal/PortalNew";
import PortalTrack from "@/pages/portal/PortalTrack";
import PortalTicket from "@/pages/portal/PortalTicket";
import { AuthProvider } from "@/context/AuthContext";
import { PolesProvider } from "@/context/PolesContext";
import ProtectedRoute from "@/components/ProtectedRoute";

const STAFF_ROLES = ["admin", "responsable", "employe"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PolesProvider>
        <BrowserRouter>
          <Routes>
            {/* Racine → portail client public */}
            <Route path="/" element={<Navigate to="/portail" replace />} />
            <Route path="/login" element={<Login />} />
            {/* Public client portal */}
            <Route path="/portail" element={<PortalLayout />}>
              <Route index element={<Portal />} />
              <Route path="nouveau" element={<PortalNew />} />
              <Route path="suivi" element={<PortalTrack />} />
              <Route path="suivi/:token" element={<PortalTicket />} />
            </Route>
            {/* Internal back-office */}
            <Route element={<Layout />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="envoyer" element={<Envoyer />} />
              <Route path="pole/:poleId" element={<PoleView />} />
              <Route path="recherche" element={<Recherche />} />
              <Route path="admin" element={<Admin />} />
              <Route
                path="performance"
                element={<ProtectedRoute roles={STAFF_ROLES}><PerformanceProposal /></ProtectedRoute>}
              />
              <Route
                path="performance/detail"
                element={<ProtectedRoute roles={STAFF_ROLES}><Performance /></ProtectedRoute>}
              />
              <Route
                path="performance/proposition"
                element={<Navigate to="/performance" replace />}
              />
              <Route
                path="performance/apercu"
                element={<ProtectedRoute roles={["admin"]}><PerfAdminMockup /></ProtectedRoute>}
              />
              <Route
                path="performance/admin"
                element={<ProtectedRoute roles={["admin"]}><PerfAdmin /></ProtectedRoute>}
              />
              <Route
                path="commandes"
                element={<ProtectedRoute roles={STAFF_ROLES}><Commandes /></ProtectedRoute>}
              />
              <Route
                path="tickets"
                element={<ProtectedRoute roles={STAFF_ROLES}><TicketsList /></ProtectedRoute>}
              />
              <Route
                path="tickets/:id"
                element={<ProtectedRoute roles={STAFF_ROLES}><TicketDetail /></ProtectedRoute>}
              />
            </Route>
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/portail" replace />} />
          </Routes>
        </BrowserRouter>
        </PolesProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
